import { getColorPreference, reflectColorPreference, setColorPreference } from "../vendor/@practical-computer/practical-views/util/theme-preference";

async function selectEventHandler(event) {
  const element = event.currentTarget;
  await element.reflectSelection(event.detail.item.value);
}

class ThemeToggleElement extends HTMLElement {
  connectedCallback() {
    if(!this.isConnected){ return }

    this.addEventListener(`wa-select`, selectEventHandler)

    this.setAttribute(`selected-theme`, getColorPreference())
  }

  async reflectSelection(newValue) {
    setColorPreference(newValue)
    reflectColorPreference()
    this.setAttribute(`selected-theme`, newValue)

    if(this.canSync) {
      await this.sync(newValue)
    }
  }

  async sync(newValue) {
    const data = new FormData(this.syncFormElement)
    data.set(`account[theme]`, newValue)
    window.mrujs.fetch(this.syncFormElement.action, {
      method: this.syncFormElement.method,
      body: data
    })
  }

  get canSync() {
    return this.hasAttribute(`sync`)
  }

  get syncFormElement() {
    return this.querySelector(`:scope > [data-sync-form]`)
  }
}

if (!window.customElements.get(`theme-toggle-element`)) {
  window.customElements.define(`theme-toggle-element`, ThemeToggleElement);
}
